import { render, staticRenderFns } from "./appointmentDelivery.vue?vue&type=template&id=50540f92&scoped=true&"
import script from "./appointmentDelivery.vue?vue&type=script&lang=js&"
export * from "./appointmentDelivery.vue?vue&type=script&lang=js&"
import style0 from "./appointmentDelivery.vue?vue&type=style&index=0&id=50540f92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50540f92",
  null
  
)

export default component.exports